import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import ManageCompanyLayer from "../../../components/Admin/ManageCompanyLayer";

const ManageCompany = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageCompanyLayer />
      </MasterLayout>
    </>
  );
};

export default ManageCompany